// extracted by mini-css-extract-plugin
module.exports = {"corner":"HudCorners_corner__7P_7I","tl":"HudCorners_tl__74eQs","tr":"HudCorners_tr__PE779","bl":"HudCorners_bl__n7PgV","br":"HudCorners_br__Mu0oY"};